import { Row } from '@tanstack/react-table';
import { LTCAppeal } from '@scts/models';

interface Props {
    row: Row<LTCAppeal>
}

export const AppealsRow = (props: Props) => {

    const formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
      });
    return (
        <tr>
            <td>{props.row.original.assessorReference ? props.row.original.assessorReference : 'N/A'}</td>
            <td>{props.row.original.propertyType ? props.row.original.propertyType : 'N/A'}</td>
            <td>{props.row.original.netAnnualValue ? formatter.format(Number(props.row.original.netAnnualValue)) : 'N/A'}</td>
            <td>{props.row.original.rateableValue ? formatter.format(Number(props.row.original.rateableValue)) : 'N/A'}</td>
            <td>{props.row.original.effectiveDate ? new Date(props.row.original.effectiveDate).toLocaleDateString() : 'N/A'}</td>
            <td>{props.row.original.appealReason ? props.row.original.appealReason : 'N/A'}</td>
        </tr> 
    );
};

export const AppealsSecondaryRow = (props: Props) => {

    return (
        <tr>
            <td>{props.row.original.address ? props.row.original.address : 'N/A'}</td>
            <td>{props.row.original.valuationRollReference ? props.row.original.valuationRollReference : "N/A"}</td>
        </tr> 
    );
};